export class User {
    public userId: number;
    public emailId: string;
    public userName: string;
    public designationId: number;
    public designation: string;
    public isAdmin: boolean;
    public isLog: boolean;
}